// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateTransferComment = transfer =>
    dispatch => dispatch({
        data: transfer,
        type: actions.UPDATE_TRANSFER_COMMENT_SUCCESS
    });



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/comment.js